export const login = {
  headline: 'Login',
  inputLabels: {
    userNameOrEmail: 'Username or Email',
    password: 'Password',
    oldPassword: 'Current password',
    newPassword: 'New password',
    repeatPassword: 'Repeat password'
  },
  mainActions: {
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot password',
    resetPassword: 'Reset password'
  },
  messages: {
    loginFailed: `Username and password don't match.`,
    membersOnly: '(members only)',
    passwordResetSuccess: {
      header: 'Password changed',
      body: `Your password has been change. You're now able to login with your new password`
    }
  }
}